import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b9e727a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "clinic-daily-routine__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-content-page-title w-full pb-2" }, "スタッフシフト", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro w-full" }, [
  /*#__PURE__*/_createElementVNode("p", null, "店舗の設定時間の範囲内でスタッフ様毎に出勤時間と退勤時間の設定を行えます。")
], -1))
const _hoisted_4 = { class: "grid flex align-items-center my-4" }
const _hoisted_5 = { class: "month lg:col-2 sm:col-12" }
const _hoisted_6 = { class: "flex justify-content-end" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-content-center h-full"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-6 lg:col-offset-1 lg:col-10 md:col-12 sm:col-12"
}
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = { class: "flex-initial flex justify-content-start sm:justify-content-center col-10" }

import { IClinicSettingStaffShift, ApiBaseReq, ApiClinicSettingStaffShiftParams } from "@/clinic/typings";
import { AxiosResponse } from "axios";
import { get, set } from "@vueuse/core";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { ref, reactive, computed, withDefaults, onBeforeMount } from "vue";
import { useToast } from "primevue/usetoast";
import { ClinicStaffShiftsService } from "@/clinic/services";
import DateComponent from "../common/date.vue";
import SpecialDateComponent from "../common/special-date.vue";
import Toast from "primevue/toast";
import { StaffServices } from "@/clinic/services";
import { ApiStaffIndexRes } from "@/clinic/typings";
import { WeekDays } from "@/clinic/typings/constants/clinic";
import ClinicApplySettingPrevMonthService from "@/clinic/services/clinic/apply-prev-month";
import moment from "moment";

type IForm = {
  clinicId: number;
  hasEdit?: boolean;
};

/**
 * propsの定義
 * @type {IForm}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    clinicId: null,
    hasEdit: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { clinicId: number, hasEdit: boolean };

/**
 * スタッフシフト画面用コンポーネント
 * クリニックの日次シフト管理画面を提供する
 * - 当月・前月・翌月のスタッフシフト表示・編集
 * - 前月設定のコピー機能
 * - 特殊勤務日の追加・削除
 *
 * @component
 */
const toast = useToast();

/** スタッフ選択状態フラグ */
const isStaffSelected = ref(false);

/**
 * フォームの型定義
 * @typedef {Object} IForm
 * @property {number} clinicId - クリニックのID
 * @property {boolean} [hasEdit] - 編集可能かどうかのフラグ
 */


/**
 * 現在の日付情報を取得する
 *
 * @returns {{year: number, month: string}} 年と月のオブジェクト
 */
const getCurrentDate = computed(() => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1);
  return { year, month };
});

/** 一覧用スタッフデータ */
const staffs = ref([]);
/** 選択中スタッフID */
const staffSelected = ref(null);

/** ローディング状態フラグ */
const isLoading = ref(true);
/** フォームデータ */
const form = reactive<any>({});
/** DateComponent参照配列 */
const dateElements = ref([]);
/** SpecialDateComponent参照配列 */
const specialDateElements = ref([]);

/** デフォルト日付フォーマット */
const getCurrentDateFormat = ref(moment().format("YYYY-MM-DD"));

/** デフォルト特殊日付オブジェクト */
const defaultSpecialDateObject = ref({
  date: getCurrentDateFormat,
  clinic_id: props.clinicId,
  clinic_staff_shift_id: null,
  morning_shift_start: "8",
  morning_shift_start_minutes: "0",
  morning_shift_end: "12",
  morning_shift_end_minutes: "0",
  afternoon_shift_start: "13",
  afternoon_shift_start_minutes: "0",
  afternoon_shift_end: "18",
  afternoon_shift_end_minutes: "0",
  _destroy: false,
});

/**
 * 特殊勤務日の入力項目を追加する
 *
 * @function
 */
const addMoreSpecialDate = () => {
  const days = form.clinic_special_staff_shifts_attributes;
  set(form.clinic_special_staff_shifts_attributes, days.push(defaultSpecialDateObject.value));
};

/**
 * 特殊勤務日の入力項目を削除する
 *
 * @function
 * @param {number} index - 削除対象のインデックス
 */
const onDeleteDate = index => {
  get(specialDateElements)[index].destroyDate();
  let days = form.clinic_special_staff_shifts_attributes;
  if (days[index].id) {
    days[index]._destroy = true;
  } else {
    days.splice(index, 1);
  }
  set(form.clinic_special_staff_shifts_attributes, days);
  set(pass, true);
};

/**
 * スタッフ選択時にモデルをロードし、選択状態フラグを更新する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const onChangingStaff = async () => {
  await loadModel();
  isStaffSelected.value = true;
};

/**
 * 月を変更してデータを再読み込みする
 *
 * @async
 * @function
 * @param {'prev'|'next'} direction - 'prev' または 'next'
 * @returns {Promise<void>}
 */
const handleChangeMonth = async (direction: string) => {
  let year = form.year;
  let month = form.month;
  if (direction === "next") {
    if (++month > 12) {
      year++;
      month = 1;
    }
  } else {
    if (--month <= 0) {
      year--;
      month = 12;
    }
  }
  await loadDate(month, year);
  await loadModel();
  set(getCurrentDateFormat, moment(`${get(form.year)}-${get(form.month)}-01`, "YYYY-MM-DD").format("YYYY-MM-DD"));
};

/**
 * 前月設定をコピーして適用する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const handleApplyPrevMonth = async () => {
  const { prevMonth, prevYear } = handleGetNumberPreMonth(get(form.month), get(form.year));
  const params = {
    prev_month: prevMonth,
    prev_year: prevYear,
    month: get(form.month),
    year: get(form.year),
    staff_id: Number(get(staffSelected)),
    clinic_id: props.clinicId,
  };
  await ClinicStaffShiftsService.applyPrevMonthShift(
    params,
    () => notifySuccessMsg(toast, "保存が完了しました"),
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  );
  await loadModel();
};

/**
 * 前の月と年を計算する
 *
 * @function
 * @param {number} month - 現在の月
 * @param {number} year - 現在の年
 * @returns {{prevMonth: number, prevYear: number}} 前月と前年
 */
const handleGetNumberPreMonth = (month: number, year: number) => {
  if (month === 1) {
    return { prevMonth: 12, prevYear: year - 1 };
  }
  return { prevMonth: month - 1, prevYear: year };
};

/**
 * APIリクエスト用のクリニックIDパラメータを計算する
 *
 * @type {import("vue").ComputedRef<ApiBaseReq>}
 */
const clinicIdParams = computed((): ApiBaseReq => ({ clinic_id: get(props.clinicId) }));

/**
 * 入力検証の結果フラグを設定する
 *
 * @async
 * @function
 * @param {boolean} passVal - 検証結果
 * @return {Promise<void>}
 */
const validate = async (passVal: boolean) => {
  set(pass, passVal);
};

/** フォーム要素の参照 */
const formRef = ref<HTMLFormElement>();
/** フォームの検証結果フラグ */
const pass = ref(false);

/**
 * フォームデータを整形し、シフト更新APIを呼び出す
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const submit = async () => {
  // 1. 日付要素（DateComponent）から各日の入力データを取得して form.value にマージ
  get(dateElements).forEach(date => {
    const dateData = date?.getDateData();
    if (dateData !== undefined) {
      // 取得した dateData 内の “_minute” フィールドを整形
      Object.keys(dateData).forEach(key => {
        // 分単位入力かつ値が "0" 以外のとき
        if (key.endsWith("_minute") && dateData[key]?.value !== "0") {
          const fieldName = key.replace("_minute", "");
          if (dateData[fieldName] === "NaN") {
            // 時刻部分が NaN の場合は null に置き換え
            dateData[fieldName] = null;
          } else if (dateData[fieldName] !== null) {
            // 有効な時刻文字列に “:分” を付与
            dateData[fieldName] += `:${dateData[key].value}`;
          }
        }
      });
      // 整形後の dateData を form.value に統合
      form.value = { ...form.value, ...dateData };
    }
  });

  // 2. 特殊勤務日要素（SpecialDateComponent）から特殊勤務日のデータを取得し、API用配列を構築
  let clinic_special_staff_shifts_attributes: any[] = [];
  get(specialDateElements).forEach(specialDate => {
    if (specialDate?.getSpecialDateData() !== undefined) {
      // 休業日の場合は空文字、それ以外は "時:分" 形式で文字列生成
      const objectSpecialDate = specialDate?.getSpecialDateData();
      const morning_shift_start = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.morning_shift_start}:${objectSpecialDate.morning_shift_start_minutes}`;
      const morning_shift_end = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.morning_shift_end}:${objectSpecialDate.morning_shift_end_minutes}`;
      const afternoon_shift_start = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.afternoon_shift_start}:${objectSpecialDate.afternoon_shift_start_minutes}`;
      const afternoon_shift_end = objectSpecialDate.day_off
        ? ""
        : `${objectSpecialDate.afternoon_shift_end}:${objectSpecialDate.afternoon_shift_end_minutes}`;
      // 配列にプッシュ
      clinic_special_staff_shifts_attributes.push({
        clinic_id: objectSpecialDate.clinic_id,
        date: objectSpecialDate.date,
        morning_shift_start: morning_shift_start,
        morning_shift_end: morning_shift_end,
        afternoon_shift_start: afternoon_shift_start,
        afternoon_shift_end: afternoon_shift_end,
        _destroy: objectSpecialDate?._destroy,
        id: objectSpecialDate.id,
      });
    }
  });

  // 3. バリデーション結果が false なら処理中断
  if (!get(pass)) return;

  // 4. フォームデータを整形して API リクエスト用のpayload と params を作成
  const formData = { ...form.value, ...{ clinic_id: get(props.clinicId), month: form.month, year: form.year } };
  formData.clinic_special_staff_shifts_attributes = clinic_special_staff_shifts_attributes;
  const payload = { ...formData };
  const params = {
    ...get(clinicIdParams),
    staff_id: Number(get(staffSelected)),
    year: form.year,
    month: form.month,
  } as ApiClinicSettingStaffShiftParams;

  // 5. 更新API リクエストを実行
  await ClinicStaffShiftsService.updateShift(
    params,
    payload,
    () => notifySuccessMsg(toast, "保存が完了しました"),
    () => notityErrorMsg(toast, "設定に誤りがあります。入力内容を確認してください")
  );

  // 6. 再読み込みして最新データをフォームに反映
  await loadModel();
};

/**
 * スタッフ一覧をAPIから取得して設定する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const loadStaffs = async () => {
  const { data } = await StaffServices.getStaffs(get(clinicIdParams));
  const { staffs: StaffList } = get(get(data) as unknown as ApiStaffIndexRes);
  set(staffs, get(StaffList));
};

/**
 * フォームの日付情報を設定する
 *
 * @function
 * @param {string|null} month - 月
 * @param {string|null} year - 年
 */
const loadDate = (month: string | null = null, year: string | null = null) => {
  if (!month || !year) {
    const date = get(getCurrentDate);
    form.year = date.year;
    form.month = date.month;
  } else {
    form.year = year;
    form.month = month;
  }
};

/**
 * シフトモデルデータを取得してフォームに設定する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const loadModel = async () => {
  set(isLoading, true);
  const params = {
    ...get(clinicIdParams),
    staff_id: Number(get(staffSelected)),
    year: form.year,
    month: form.month,
  } as ApiClinicSettingStaffShiftParams;

  const { data } = (await ClinicStaffShiftsService.getShift(
    params,
    () => true,
    () => notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください")
  )) as unknown as AxiosResponse<IClinicSettingStaffShift>;

  form.clinic_id = +props.clinicId;
  await Object.assign(form, await get(data));
  set(isLoading, false);
};

/**
 * コンポーネントマウント前にスタッフ一覧と日付を初期ロードする
 */
onBeforeMount(async () => {
  await loadStaffs();
  await loadDate();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(form.year) + " 年 " + _toDisplayString(form.month) + "月", 1),
        _createVNode(_component_Button, {
          class: "p-button-light mr-2 h-48px lg:col-2",
          label: "前月の設定へ",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeMonth('prev')))
        }),
        _createVNode(_component_Button, {
          class: "p-button-light mr-2 h-48px lg:col-2",
          label: "翌月の設定へ",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeMonth('next')))
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: "前月分をコピー",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleApplyPrevMonth())),
            class: "ml-5 w-100",
            disabled: !isStaffSelected.value
          }, null, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_Dropdown, {
        modelValue: staffSelected.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((staffSelected).value = $event)),
        optionLabel: "name_kanji",
        optionValue: "id",
        placeholder: "担当スタッフ",
        class: "selectStaff",
        options: staffs.value,
        onChange: onChangingStaff
      }, null, 8, ["modelValue", "options"]),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            form
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (form && staffSelected.value)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        onSubmit: _withModifiers(submit, ["prevent"]),
                        ref_key: "formRef",
                        ref: formRef
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WeekDays), (day, index) => {
                          return (_openBlock(), _createBlock(DateComponent, {
                            key: index,
                            name: day,
                            data: _unref(get)(form),
                            onValidateFn: validate,
                            ref_for: true,
                            ref: 
              el => {
                dateElements.value[index] = el;
              }
            
                          }, null, 8, ["name", "data"]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.clinic_special_staff_shifts_attributes, (specialDate, index) => {
                          return (_openBlock(), _createBlock(SpecialDateComponent, {
                            key: specialDate,
                            data: specialDate,
                            index: index,
                            onOnDeleteDate: onDeleteDate,
                            onValidateFn: validate,
                            ref_for: true,
                            ref: 
              el => {
                specialDateElements.value[index] = el;
              }
            
                          }, null, 8, ["data", "index"]))
                        }), 128)),
                        _createVNode(_component_Button, {
                          label: "追加する",
                          onClick: addMoreSpecialDate,
                          class: "mb-5"
                        }),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_Button, {
                            label: "保存する",
                            type: "submit",
                            class: "w-6",
                            disabled: !_unref(get)(pass.value)
                          }, null, 8, ["disabled"])
                        ])
                      ], 40, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})